module.exports = __webpack_public_path__ + "img/main.02fe6078.jpg";